import React from "react";
import { Grid, Container } from "@material-ui/core";
import WelcomeBanner from "../shared/welcomeBanner/welcomeBanner";
import Footer from "../footer/Footer";
import MFAButton from "../shared/button/buttonMFA/buttonMFA";
import { useStyles, MFALogic } from "./MFA.module";

export default function MFA() {
  const classes = useStyles();
  const {
    translator,
    otp,
    inputRefs,
    counter,
    canResend,
    loading,
    resendMessage,
    handleChange,
    handleKeyDown,
    handlePaste,
    handleResendClick,
    handleVerify,
  } = MFALogic();

  return (
    <div>
      <Container maxWidth="lg">
        <Grid container align="center" spacing={2} className={classes.rootMFA}>
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className={classes.welcomeBanner}
          >
            <WelcomeBanner
              text={
                <>
                  <strong>{translator("mfa.bannerTitle")}</strong>
                  <br />
                  {translator("mfa.bannerSubTitle")}
                </>
              }
            />
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className={classes.containerMFA}
          >
            <h2 className={classes.titleMFA}>{translator("mfa.title")}</h2>
            <p className={classes.textExplainMFA}>{translator("mfa.text")}</p>
            <div className={classes.formMFA}>
              <label className={classes.labelsMFA}>
                {translator("mfa.code")}
              </label>
              <Grid
                container
                justifyContent="center"
                spacing={1}
                className={classes.otpWrapper}
              >
                {otp.map((data, index) => (
                  <Grid item key={index}>
                    <input
                      type="text"
                      maxLength="1"
                      value={data}
                      onChange={(e) => handleChange(e.target, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handlePaste}
                      ref={(el) => (inputRefs.current[index] = el)}
                      className={classes.otpInput}
                    />
                  </Grid>
                ))}
              </Grid>
              <Grid container>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className={classes.passwordHelper}
                >
                  {translator("mfa.helper")}
                </Grid>
              </Grid>
              {resendMessage && (
                <div
                  style={{
                    color: "#1976d2",
                    textAlign: "center",
                    marginTop: 12,
                  }}
                >
                  {resendMessage}
                </div>
              )}
              <Grid
                justify="space-between"
                container
                spacing={1}
                className={classes.containerButtons}
              >
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <MFAButton
                    type="blue"
                    text={loading ? "Verificando..." : translator("mfa.button")}
                    isSubmit={false}
                    onClick={handleVerify}
                    disabled={loading}
                  />
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  style={{
                    marginTop: "10px",
                    cursor: canResend && !loading ? "pointer" : "default",
                    color: canResend && !loading ? "#1976d2" : "#999",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onClick={handleResendClick}
                >
                  {canResend ? "Reenviar código" : `Reenviar código en ${counter}s`}
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
}
